<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div v-if="user" class="modal-body-container text-center d-flex">
            <h4 class="text-center mt-4">{{user.firstName}} {{ user.lastName }}</h4>    
            <span>{{ user.email }}</span>    
            <span>{{ user.phoneNumber }}</span> 
            <div v-if="!loading" class="d-flex justify-content-center my-2">
                <div class="d-flex flex-column mr-2">
                    <span class="font-weight-bold">{{ getTotalPointsForUserOutput }}</span>
                    <span>{{ $t("totalPoints") }}</span>
                </div>
                <div class="d-flex flex-column ml-2">
                    <span class="font-weight-bold">{{ getAvailablePointsForUserOutput }}</span>
                    <span>{{ $t("availablePoints") }}</span>
                </div>
            </div>   
            <CDataTable :items="items" :fields="fields" :loading="loading">
            </CDataTable>
            <div class="d-flex justify-content-center">
                <CButton type="button" class="mb-4 btn btn-secondary mr-1" @click="deductPointsRequested">{{ $t('deductPoints') }}</CButton>
                <CButton type="button" class="mb-4 btn btn-primary ml-1" @click="closeConfirmRequested">{{ $t('close') }}</CButton>
            </div>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';
import { mapState, mapActions } from 'vuex'

export default {
    extends: BasePopUp,
    components: {BasePopUp},
    computed:
    {
        fields: function()
        {
            return [
                { key: 'date', label: this.$i18n.t('date')  },
                { key: 'type', label: this.$i18n.t('type') },
                { key: 'description', label: this.$i18n.t('description') }
            ];
        },
        ...mapState('pointMovements', ['getPointMovementsForUserOutput']),
        ...mapState('pointMovements', ['getTotalPointsForUserOutput']),
        ...mapState('pointMovements', ['getAvailablePointsForUserOutput']),
        ...mapState('pointMovements', ['postPointMovementOutput']),
        ...mapState('voteMovements', ['getVoteMovementsForUserOutput']),
        ...mapState('sessions', ['getSessionsForUserOutput']),
        items: function()
        {
            var result = [];

            if(this.getPointMovementsForUserOutput && Array.isArray(this.getPointMovementsForUserOutput))
            {
                let self = this;
                result = this.getPointMovementsForUserOutput.map(x=> ({date: x.date.replace("T", " "). slice(0, 19), type: self.$i18n.t('points'), description: x.points}));

                if(this.getVoteMovementsForUserOutput && Array.isArray(this.getVoteMovementsForUserOutput)) result = result.concat(this.getVoteMovementsForUserOutput.map(x=> ({date: x.date.replace("T", " ").slice(0, 19), type: self.$i18n.t('vote'), description: x.isUpvote ? self.$i18n.t('upvote') : self.$i18n.t('downvote')})));
                if(this.getSessionsForUserOutput && Array.isArray(this.getSessionsForUserOutput)) result = result.concat(this.getSessionsForUserOutput.map(x=> ({date: x.date.replace("T", " ").slice(0, 19), type: self.$i18n.t('session'), description: ''})));
                
                result = result.sort((a, b) => (a.date < b.date) ? 1 : -1);
            }

            return result;
        },
        loading: function()
        {
            return this.postPointMovementOutput === null;
        }
    },
    methods:{
        ...mapActions('pointMovements', ['getPointMovementsForUser']),
        ...mapActions('pointMovements', ['getTotalPointsForUser']),
        ...mapActions('pointMovements', ['getAvailablePointsForUser']),
        ...mapActions('pointMovements', ['postPointMovement']),
        ...mapActions('voteMovements', ['getVoteMovementsForUser']),
        ...mapActions('sessions', ['getSessionsForUser']),
        closeConfirmRequested(event)
        {       
            this.$emit("closeConfirmRequested");
        },
        deductPointsRequested()
        {
            var result = prompt(this.$i18n.t('deductPointsDescription'));
            if(result && !isNaN(result))
            {
                var points = Number(result);
                if(points > 0) points = -points;

                this.postPointMovement({points: points});
            }
        }
    },
    props:{
        user:
        {
            type: Object,
            default: null
        },
    },
    mounted: function()
    {
        if(this.user)
        {
            this.getPointMovementsForUser(this.user.id);
            this.getTotalPointsForUser(this.user.id);
            this.getAvailablePointsForUser(this.user.id);
            this.getVoteMovementsForUser(this.user.id);
            this.getSessionsForUser(this.user.id);
        }
    },
    watch: 
    {
        user: function()
        {
            if(this.user)
            {
                this.getPointMovementsForUser(this.user.id);
                this.getTotalPointsForUser(this.user.id);
                this.getAvailablePointsForUser(this.user.id);
                this.getVoteMovementsForUser(this.user.id);
                this.getSessionsForUser(this.user.id);
            }
        },
        postPointMovementOutput: function(val)
        {
            if(val)
            {
                this.getPointMovementsForUser(this.user.id);
                this.getTotalPointsForUser(this.user.id);
                this.getAvailablePointsForUser(this.user.id);
                this.getVoteMovementsForUser(this.user.id);
                this.getSessionsForUser(this.user.id);
            }
        }
    }
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    
    }
</style>